<mat-tab-group
  [animationDuration]="animationDuration"
  [selectedIndex]="selected"
  (selectedIndexChange)="selected = $event; select.emit(tabs[$event])"
>
  <mat-tab
    *ngFor="let tab of tabs"
    (click)="onTabClick(tab)"
    id="tab-{{ tab.value }}"
    [class.active]="tab.active"
  >
    <ng-template mat-tab-label>
      <div class="name">{{ tab.name }}</div>
      <div *ngIf="tab.counter$" class="counter">{{ tab.counter$ | async }}</div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
